import { AxiosResponse } from "axios";
import axios from "./config";
import { ReportApiResponse } from "app/types";

export const downloadSalesReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(`/stores/${storeId}/reports/sales${query}`);

export const downloadTopUpReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(`/stores/${storeId}/reports/top-up${query}`);

export const downloadDetailedDeliveryReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/detailed-delivery${query}`
  );

export const downloadPaidClientReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/paid-client${query}`
  );

export const downloadConfirmedBoxesReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/confirmed-boxes${query}`
  );

export const getClientReportsAPI = ({
  query,
  storeId,
}: {
  query: string;
  storeId: number;
}): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(`/stores/${storeId}/reports/clients${query}`);

export const getUnconfirmedOrdersAutoSelectionsReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/unconfirmed-auto-selections${query}`
  );

export const getDeliveryShiftCountReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/delivery-shift-counts${query}`
  );

export const downloadExtraDaysReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/subscription-days-modifications-report${query}`
  );

export const getSubscriptionReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/fetch-subscription-data${query}`
  );

export const getMealSalesReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/meal-selections-report${query}`
  );

export const getClientBirthdayReportAPI = (
  query: string,
  storeId: number
): Promise<AxiosResponse<ReportApiResponse>> =>
  axios.get<ReportApiResponse>(
    `/stores/${storeId}/reports/clients-birthday${query}`
  );
